document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.medical-slider');
    const track = document.querySelector('.medical-slider__track');

    if (!slider || !track) return;

    const originalCards =
        track.querySelectorAll('.article-card').length / 3;

    let isDragging = false;

    let startX = 0;
    let startY = 0;

    let currentTranslate = 0;

    let previousTranslate = 0;

    let moved = false;

    let autoPlay;

    let isHorizontalDrag = false;

    /*
    |--------------------------------------------------------------------------
    | ANCHO BLOQUE ORIGINAL
    |--------------------------------------------------------------------------
    */

    function getOriginalWidth() {

        const cards =
            track.querySelectorAll('.article-card');

        let width = 0;

        for (let i = 0; i < originalCards; i++) {

            width += cards[i].offsetWidth;

            if (i < originalCards - 1) {
                width += 18;
            }
        }

        return width;
    }

    /*
    |--------------------------------------------------------------------------
    | LOOP INFINITO
    |--------------------------------------------------------------------------
    */

    function checkLoop() {

        const originalWidth =
            getOriginalWidth();

        if (
            Math.abs(currentTranslate)
            >= originalWidth * 2
        ) {

            currentTranslate += originalWidth;

            previousTranslate =
                currentTranslate;
        }

        if (
            currentTranslate > 0
        ) {

            currentTranslate -= originalWidth;

            previousTranslate =
                currentTranslate;
        }
    }

    /*
    |--------------------------------------------------------------------------
    | TRANSFORM
    |--------------------------------------------------------------------------
    */

    function updatePosition() {

        track.style.transform =
            `translateX(${currentTranslate}px)`;
    }

    /*
    |--------------------------------------------------------------------------
    | AUTOPLAY
    |--------------------------------------------------------------------------
    */

    function startAutoPlay() {

        stopAutoPlay();

        autoPlay = setInterval(() => {

            currentTranslate -= 0.6;

            checkLoop();

            updatePosition();

        }, 16);
    }

    function stopAutoPlay() {

        clearInterval(autoPlay);
    }

    function restartAutoPlay() {

        clearTimeout(track.resumeTimer);

        track.resumeTimer = setTimeout(() => {

            startAutoPlay();

        }, 3000);
    }

    /*
    |--------------------------------------------------------------------------
    | CLICK
    |--------------------------------------------------------------------------
    */

    slider.addEventListener('click', (event) => {

        if (moved) {

            event.preventDefault();

            moved = false;

            return;
        }

        stopAutoPlay();

        restartAutoPlay();
    });

    /*
    |--------------------------------------------------------------------------
    | MOUSE
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
        'mousedown',
        startDrag
    );

    window.addEventListener(
        'mousemove',
        drag
    );

    window.addEventListener(
        'mouseup',
        endDrag
    );

    /*
    |--------------------------------------------------------------------------
    | TOUCH
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
        'touchstart',
        startDrag,
        { passive: true }
    );

    slider.addEventListener(
        'touchmove',
        drag,
        { passive: false }
    );

    slider.addEventListener(
        'touchend',
        endDrag
    );

    slider.addEventListener(
        'touchcancel',
        endDrag
    );

    /*
    |--------------------------------------------------------------------------
    | START
    |--------------------------------------------------------------------------
    */

    function startDrag(event) {

        stopAutoPlay();

        clearTimeout(track.resumeTimer);

        isDragging = true;

        moved = false;

        isHorizontalDrag = false;

        startX = getPositionX(event);

        startY = getPositionY(event);

        previousTranslate =
            currentTranslate;
    }

    /*
    |--------------------------------------------------------------------------
    | DRAG
    |--------------------------------------------------------------------------
    */

    function drag(event) {

        if (!isDragging) return;

        const currentX =
            getPositionX(event);

        const currentY =
            getPositionY(event);

        const diffX =
            currentX - startX;

        const diffY =
            currentY - startY;

        /*
        |--------------------------------------------------------------------------
        | SI EL MOVIMIENTO ES MÁS VERTICAL
        |--------------------------------------------------------------------------
        */

        if (!isHorizontalDrag) {

            if (
                Math.abs(diffY)
                > Math.abs(diffX)
            ) {

                endDrag();

                return;
            }

            if (
                Math.abs(diffX) > 10
            ) {

                isHorizontalDrag = true;
            }
        }

        if (!isHorizontalDrag) return;

        if (event.cancelable) {
            event.preventDefault();
        }

        if (Math.abs(diffX) > 5) {

            moved = true;
        }

        currentTranslate =
            previousTranslate + diffX;

        checkLoop();

        updatePosition();
    }

    /*
    |--------------------------------------------------------------------------
    | END
    |--------------------------------------------------------------------------
    */

    function endDrag() {

        if (!isDragging) return;

        isDragging = false;

        isHorizontalDrag = false;

        restartAutoPlay();
    }

    /*
    |--------------------------------------------------------------------------
    | UTILIDADES
    |--------------------------------------------------------------------------
    */

    function getPositionX(event) {

        return event.type.includes('mouse')
            ? event.pageX
            : event.touches[0].clientX;
    }

    function getPositionY(event) {

        return event.type.includes('mouse')
            ? event.pageY
            : event.touches[0].clientY;
    }

    /*
    |--------------------------------------------------------------------------
    | INIT
    |--------------------------------------------------------------------------
    */

    startAutoPlay();

});